import { render, staticRenderFns } from "./runForMoney_bak.vue?vue&type=template&id=09093d86&"
import script from "./runForMoney_bak.vue?vue&type=script&lang=js&"
export * from "./runForMoney_bak.vue?vue&type=script&lang=js&"
import style0 from "./runForMoney_bak.vue?vue&type=style&index=0&id=09093d86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports